export default "__VITE_ASSET__832a66de__"